export const ENTITY = 'COLLEGIAL_ORGANIZATION';